import React from 'react';
import PropTypes from 'prop-types';
import styles from './trialOverviewMsg.module.css';

export const TrialOverviewMsg = ({ content }) => {
  const {
    intro, totals, breakdown, highlights,
  } = content;

  const { byPhase, byStudyType, topLocations } = breakdown;

  const renderCounts = (entries) => (
    <ul className={styles.list}>
      {Object.entries(entries).map(([key, value]) => (
        <li key={key}>
          <strong>{key}</strong>
          {`: ${value}`}
        </li>
      ))}
    </ul>
  );

  return (
    <>
      {intro ? <p className={styles.intro}>{intro}</p> : null}
      <div className={styles.card}>
        <h4 className={styles.header}>
          {`Your Matched Trials Overview (${totals.trials} Found)`}
        </h4>

        <div className={styles.section}>
          <strong className={styles.sectionTitle}>By Phase</strong>
          {renderCounts(byPhase)}
        </div>
        <div className={styles.section}>
          <strong className={styles.sectionTitle}>By Study Type</strong>
          {renderCounts(byStudyType)}
        </div>
        <div className={styles.section}>
          <strong className={styles.sectionTitle}>Top Locations</strong>
          {renderCounts(topLocations)}
        </div>

        <div className={styles.divider}>
          <strong className={styles.footerTitle}>Trial Highlights (Top 3):</strong>
          <ul className={styles.list}>
            {(Array.isArray(highlights) ? highlights.slice(0, 3) : []).map((highlight, idx) => (
              <li key={highlight.nct || idx}>
                <strong>{highlight.title}</strong>
                {`(NCT: ${highlight.nct})`}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <p className={styles.footerText}>
        Would you like me to dive into the details of any of these trials?
        {' '}
        You can ask about a specific one by its NCT number.
      </p>
    </>
  );
};

TrialOverviewMsg.propTypes = {
  content: PropTypes.shape({
    intro: PropTypes.string.isRequired,
    totals: PropTypes.shape({
      trials: PropTypes.number.isRequired,
    }).isRequired,
    breakdown: PropTypes.shape({
      byPhase: PropTypes.objectOf(PropTypes.number).isRequired,
      byStudyType: PropTypes.objectOf(PropTypes.number).isRequired,
      topLocations: PropTypes.objectOf(PropTypes.number).isRequired,
    }).isRequired,
    highlights: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      nct: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};
